export default "skymp5-front/425555ed3b57a37edf88e2560ea1637f.png";